import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import ContactViewModel from '@app/models/contact-view-model';
import { PhoneNumberPipe } from '../../shared-components/pipes/phone-number.pipe';
import { LinkToUserAccountDetailComponent } from '../../common-components/link-to-user-account-detail/link-to-user-account-detail.component';
import { LinkToStripeComponent } from '../../common-components/link-to-stripe/link-to-stripe.component';


@Component({
    selector: "contact",
    templateUrl: "./contact.component.html",
    styleUrls: ["./contact.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LinkToStripeComponent, LinkToUserAccountDetailComponent, PhoneNumberPipe]
})
export class ContactComponent {
  private readonly _componentName = 'ContactComponent';
  private _value: ContactViewModel;

  /**
   * Optional parameter to explicity hide the address portion of the component
   */
  @Input() public showAddress: boolean = true;

  public get value(): ContactViewModel {
    return this._value;
  }

  @Input()
  public set value(v: ContactViewModel) {
    console.log(`${this._componentName}.value - set v=`, v);
    this._value = v;
  }

  public get hasAddress(): boolean {
    if (this.value && this.value.addressState) {
      return true;
    }
    return false;
  }

  /**
   * Returns a Full Name value to be used in the template.  fullName has 1st priority.  If it doesn't exist, then firstName lastName
   */
  public get fullName(): string {
    if (!this.value) return null;

    if (this.value && this.value.fullName) {
      return this.value.fullName;
    }

    if (this.value.firstName && this.value.lastName) {
      return `${this.value.firstName} ${this.value.lastName}`;
    }

    return null;
  }
}
